import axios from 'axios';

/**
 * FastAPI validation errors (422) carry `detail` as a list of objects. Pages pass
 * `detail` straight to toast.error, and rendering an object crashes React into a
 * blank page, so turn it into readable text once for every request.
 */
export const detailToText = (detail) => {
  if (detail == null || typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map(d => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
    return msgs.length ? `Dati non validi: ${msgs.join('; ')}` : 'Dati non validi';
  }
  if (typeof detail === 'object') return detail.message || detail.msg || JSON.stringify(detail);
  return String(detail);
};

export const installApiErrorNormalizer = () => {
  axios.interceptors.response.use(undefined, (error) => {
    const data = error?.response?.data;
    if (data && typeof data === 'object' && 'detail' in data) {
      data.detail = detailToText(data.detail);
    }
    return Promise.reject(error);
  });
};
